import apiClient from '../plugins/axios';

/**
 * STT Service – POST /stt/transcribe uses X-Api-Key header.
 */
class SttService {
  /**
   * Transcribe audio. POST /stt/transcribe – multipart file. Uses X-Api-Key header.
   * @param {string} apiToken
   * @param {File} file
   * @returns {Promise<{ success: boolean, message?: string, data?: unknown }>}
   */
  async transcribe(apiToken, file) {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post('/stt/transcribe', formData, { headers: { 'X-Api-Key': apiToken } });
    return response.data;
  }
}

export default new SttService();
